import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import TextField from 'components/fields/TextField';
import CheckboxField from 'components/fields/CheckboxField';
import IconCreditCard from 'components/icons/IconCreditCard';

import {
  createPatientCreditCard,
  updatePatientCreditCard,
} from 'redux/modules/patientsCreditCards';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';
import objectDiff from 'utils/objectDiff';

const styles = () => ({
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
  iconCreditCard: {
    width: 20,
    height: 16,
  },
});

function onSubmit(values, dispatch, props) {
  if (props.ID) {
    if (props.pristine) {
      throw new SubmissionError({
        _error: 'Nothing to submit',
      });
    }
    const diffValues = objectDiff(values, props.initialValues);
    return new Promise((resolve, reject) => {
      dispatch(updatePatientCreditCard({
        values: {
          'User Record Number': props['User Record Number'],
          ID: props.ID,
          ...diffValues,
        },
        resolve,
        reject,
      }));
    }).then(res => res,
      (err) => {
        throw new SubmissionError(err);
      });
  }
  return new Promise((resolve, reject) => {
    dispatch(createPatientCreditCard({
      values: {
        'User Record Number': props['User Record Number'],
        ...values,
      },
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      throw new SubmissionError(err);
    });
}

function validateForm(values) {
  const errors = {};

  if (values['Date of Expiration']
  && moment(values['Date of Expiration'], 'MM/YY').isBefore(moment().startOf('month'))) {
    errors['Date of Expiration'] = 'Date of Expiration should be in future';
  }

  return errors;
}

const CreditCardsForm = props => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={props.handleSubmit}
    className={props.className}
  >
    <Grid
      className={props.classes.grid}
      container
      justify="center"
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Name on Card"
          name="Name on Card"
          label="Name on Card"
          component={TextField}
          validate={[validate.required]}
          errorPlacement="bottom"
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      className={props.classes.grid}
      container
      justify="center"
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Card Number"
          name="Card Number"
          label="Card Number"
          component={TextField}
          validate={[validate.required, validate.cardNumber]}
          normalize={normalize.cardNumber}
          maxLength="19"
          startAdornment={
            <InputAdornment position="start">
              <IconCreditCard className={props.classes.iconCreditCard} />
            </InputAdornment>
          }
          errorPlacement="top"
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      className={props.classes.grid}
      container
      justify="center"
      spacing={24}
    >
      <Grid
        item
        xs={7}
      >
        <Field
          id="Date of Expiration"
          name="Date of Expiration"
          label="Date of Expiration"
          component={TextField}
          validate={[validate.required, validate.cardExpiration]}
          normalize={normalize.cardExpiration}
          maxLength="6"
          errorPlacement="top"
          placeholder="MM/YY"
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={5}
      >
        <Field
          id="CVV"
          name="CVV"
          label="CVV"
          description={`The 3 or 4 digit
            number on your card`}
          descriptionPlacement="top"
          component={TextField}
          validate={[validate.required, validate.cardCVV]}
          normalize={normalize.cardCVV}
          maxLength="5"
          errorPlacement="top"
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      className={props.classes.grid}
      container
      justify="flex-start"
      spacing={24}
    >
      <Grid item xs={6}>
        <Field
          id="Zip Code"
          name="Zip Code"
          label="Zip Code"
          component={TextField}
          validate={[validate.required, validate.zip]}
          normalize={normalize.zip}
          maxLength="5"
          errorPlacement="top"
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      container
      justify="flex-start"
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="A default payment method"
          name="A default payment method"
          label="Set as a default payment method"
          component={CheckboxField}
        />
      </Grid>
    </Grid>
  </form>
);

CreditCardsForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
    iconCreditCard: PropTypes.string.isRequired,
  }).isRequired,
};

CreditCardsForm.defaultProps = {
  className: '',
};

export default reduxForm({
  form: 'patientCreditCards',
  onSubmit,
  validate: validateForm,
  initialValues: {
    'A default payment method': false,
  },
})(withStyles(styles)(CreditCardsForm));



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/CreditCards/CreditCardsForm.js